import { render, staticRenderFns } from "./TabNavabar.vue?vue&type=template&id=90f508c6&scoped=true"
import script from "./TabNavabar.vue?vue&type=script&lang=ts"
export * from "./TabNavabar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f508c6",
  null
  
)

export default component.exports